import {
  locationEligibilityQuery,
  type OrchestratedQuote,
} from '@b-stock/fe-core/bstock-next/queries'
import { LocationEligibilityDtoGeofencingEnum } from '@b-stock/shipment-api-client'

/**
 * Whether the selected quote's destination is inside the listing's geofence.
 * Backs `ShippingInformationCard`'s `from`-address field on the
 * `confirm_shipping_selection` analytics event.
 */
export const useAddressWithinRadius = (
  listingId: string,
  selectedQuote?: OrchestratedQuote | null
): boolean => {
  const destinationLocationId = selectedQuote?.destination.id
  const geofenceEligibility = locationEligibilityQuery.useWithOpts(
    [{ listingId, locationId: [destinationLocationId ?? ''] }],
    { enabled: !!destinationLocationId }
  )
  return (
    geofenceEligibility.data?.[0]?.geofencing ===
    LocationEligibilityDtoGeofencingEnum.Inzone
  )
}
